/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductAttributeType from './product-attribute-type';
import ProductAttributeTypeDetail from './product-attribute-type-detail';
import ProductAttributeTypeUpdate from './product-attribute-type-update';
import ProductAttributeTypeDeleteDialog from './product-attribute-type-delete-dialog';

const ProductAttributeTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductAttributeType />} />
    <Route path="new" element={<ProductAttributeTypeUpdate />} />
    <Route path=":id">
      <Route index element={<ProductAttributeTypeDetail />} />
      <Route path="edit" element={<ProductAttributeTypeUpdate />} />
      <Route path="delete" element={<ProductAttributeTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductAttributeTypeRoutes;
